import kr from 'Kr/kr';

export default class NavTo extends kr.Component {
    init() {
        this.bind();
    }

    bind() {
        this.on('click', '.js_slideto', (target, event) => {
            event.preventDefault();
            const $el = this.app.dom.$body.querySelector(target.getAttribute('href'));
            if (typeof $el === 'undefined') {
                return false;
            }
            const height = this._getOffset($el) - this._getHeaderHeight();
            window.scrollTo({
                top: height,
                left: 0,
                behavior: 'smooth'
            });
        });
    }

    _getHeaderHeight() {
        return this.$element.querySelector('.header').offsetHeight;
    }

    _getOffset(element) {
        let offsetTop = 0;
        while(element) {
            offsetTop += element.offsetTop;
            element = element.offsetParent;
        }
        return offsetTop;
    }
}

kr.registerComponent('.web__root', {
    component: NavTo
});